var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6758_5018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8 4.5L10.62 3.6C10.5525 3.255 10.245 3 9.885 3H4.5C4.0875 3 3.75 3.3375 3.75 3.75V15C3.75 15.4125 4.0875 15.75 4.5 15.75C4.9125 15.75 5.25 15.4125 5.25 15V10.5H9.45L9.63 11.4C9.6975 11.7525 10.005 12 10.365 12H14.25C14.6625 12 15 11.6625 15 11.25V5.25C15 4.8375 14.6625 4.5 14.25 4.5H10.8Z",
    fill: "#00B574"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6758_5018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.2b9d191207d3dc9d1e1d1f05218bd7b9.svg";
export { ForwardRef as ReactComponent };